export enum WarenkorbTyp {
	Warenkorb = "Warenkorb",
	Anfragekorb = "Anfragekorb"
}

export interface AddToWarenkorbResult {
	warenkorbTyp: WarenkorbTyp;
	anzahlPositionen: number;
	status: string;
	fehler: boolean;
}

export interface ShareCartResult {
	status: string;
	fehler: boolean;
}

export interface WarenkorbOverlayResponse {
	PartialView: string;
	AnzahlPositionen: number;
}
